import React from 'react';
import styles from './RelationshipMasonryLayout.module.css';

export default function RelationshipMasonryLayout({ sections }) {
  return (
    <div className={styles.masonry}>
      {sections.map(({ id, title, icon: Icon, content }) => (
        <div key={id} className={styles.card} id={id}>
          {/*<h3 className={styles.title}>
            {Icon && <Icon />} {title}
          </h3>*/}
          <div className={styles.body}>{content}</div>
        </div>
      ))}
    </div>
  );
}
